// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SouthAfrica from '../_raw/flag/icon_flag_south_africa.png';

export default () => <img src={SouthAfrica} alt="SouthAfrica" />;
